<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex xs4 mb4>
        <span class="title">{{ customer.Name }}</span>
      </v-flex>
      <v-flex xs8 mb8>
        <img
          :src="companyLogo"
          v-if="companyLogo"
          style="max-width: 300px; float: right"
        />
      </v-flex>
    </v-layout>
    <v-layout wrap class="mt-6">
      <v-flex xs12>
        <v-layout wrap>
          <v-flex xs12>
            <v-card>
              <v-card-title class="primary white--text headline"
                >Jobs List</v-card-title
              >
              <v-card-text>
                <v-flex xs12 md5>
                  <v-text-field
                    v-model="search"
                    placeholder="Search"
                    append-icon="search"
                    clearable
                  />
                </v-flex>
                <v-data-table
                  :headers="headers"
                  :items="phases"
                  class="elevation-0"
                  :search="search"
                  sort-by="dateRaised"
                  sort-desc
                  :options.sync="pagination"
                  item-key="weekEndingISO"
                  :footer-props="{ 'items-per-page-options': [20, 50, 100] }"
                >
                  <template v-slot:item.customerOrderNumber="{ value, item }">
                    {{ item.customerOrderNumber || item.orderNumber }}</template
                  >

                  <template v-slot:item.dueDate="{ value, item }">{{
                    $moment(value).format("DD/MM/YYYY")
                  }}</template>

                  <template v-slot:item.dateRaised="{ value, item }">{{
                    $moment(value).format("DD/MM/YYYY")
                  }}</template>

                  <template v-slot:item.updatedAt="{ value, item }">{{
                    $moment(value || item.dateRaised).format("DD/MM/YYYY")
                  }}</template>

                  <template v-slot:item.phases.phaseNumber="{ value, item }">{{
                    item.phases.length
                  }}</template>

                  <template v-slot:no-data>No Jobs Located</template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// SS - 10/08/2020 Changed the 'status'  field to show the phase status, rather than the job status as the job header status is
// deprecated in favour of the individual phase status now.

import selectFunctions from "@/select/SelectFunctions";

export default {
  data() {
    return {
      portalId: "",
      customer: {},

      search: "",
      pagination: {},

      headers: [
        {
          text: "Job Number",
          value: "jobNumberFormatted",
        },
        {
          text: "Phase Number",
          value: "phaseNumber",
        },
        {
          text: "Order Number",
          value: "customerOrderNumber",
        },
        {
          text: "Received Date",
          value: "dateRaised",
        },
        {
          text: "Phase Description",
          value: "description",
        },
        {
          text: "Last Updated",
          value: "updatedAt",
        },
        {
          text: "Job Status",
          value: "status",
        },
        {
          text: "Production Status",
          value: "productionStatus",
        },
      ],

      jobs: [],

      companyLogo: null,
    };
  },

  computed: {
    phases() {
      let phases = this.jobs.flatMap((job) => {
        return job.phases.map((phase) => {
          return { ...phase, ...job };
        });
      });

      console.log(phases);

      return phases;
    },
  },

  async mounted() {
    this.portalId = this.$route.params.id;
    try {
      let response = await selectFunctions.fetch(
        `${this.$root.$data.$env.VUE_APP_BACKEND_ENDPOINT}customerportal/profile/${this.portalId}`
      );
      if (response.ok) {
        this.customer = await response.json();
        response = await selectFunctions.fetch(
          `${this.$root.$data.$env.VUE_APP_BACKEND_ENDPOINT}customerportal/jobs/${this.portalId}`
        );
        if (response.ok) {
          this.jobs = await response.json();
        }
      }
    } catch (ex) {
      console.log(ex);
    }

    this.loadCompanyLogo();
  },

  methods: {
    async loadCompanyLogo() {
      let response = await selectFunctions.fetch(
        `${this.$root.$data.$env.VUE_APP_BACKEND_ENDPOINT}companyprofiles/`
      );

      if (response.ok) {
        let companyProfiles = await response.json();
        this.companyLogo = companyProfiles.companyLogo;
      }
    },
  },
};
</script>

<style></style>
